
import React, { useEffect, useState } from 'react';
import { AutoComplete, Input } from "antd";
import { ReactComponent as SearchIcon } from '../../../../../../assets/icons/search_icon.gov.svg';
import '../../../../../../styles/pages/_searchBarComponent.scss';



const SearchComponent = (props) => {
    const prefix = <SearchIcon />;
    const { Search } = Input;
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(()=>{
        if(searchTerm.length>0) {
            const filteredLocals = props.allLocals.filter( user =>
                user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.localString?.toLowerCase().includes(searchTerm.toLowerCase())
            )
            props.setDisplayedValues(filteredLocals);
        } else {
            props.setDisplayedValues(props.allLocals);
        }
    },[searchTerm])

    return (
        <div>
            <Search
                onChange={event => setSearchTerm(event.target.value)}
                bordered={false}
                allowClear={true}
                prefix={prefix}
                className="sayt-input-filter input-filter"
                size="large"
                placeholder="Search with User ID, First Name, Last Name, Email"
                enterButton
            />
        </div>
    );
};

export default SearchComponent;
